import React from "react";
import { FiPhoneCall } from "react-icons/fi";
import "./Appointment.css";

const Appointment = () => {
  const PHONE_DISPLAY = "(206) 258-7535";
  const PHONE_E164 = "(206) 258-7535"; // correct format for tel: links

  return (
    <section className="appointment">
      <div
        className="appointment__bg"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/ab3.jpg)` }}
      />
      {/* Make sure overlay doesn't block clicks */}
      <div className="appointment__overlay" aria-hidden="true" />

      <div className="appointment__content container">
        <div className="appointment__text">
          <span className="appointment__badge">Premium Service</span>
          <h2 className="appointment__title">
            Book Your <span className="highlight">Landscaping</span> Consultation
          </h2>

          <p className="appointment__description">
            Experience unmatched lawn care and maintenance services tailored for your property.
            Our expert team delivers personalized solutions to keep your outdoor spaces pristine.
          </p>

          <div className="appointment__cta">
            <a
              href={`tel:${PHONE_E164}`}
              className="appointment__button"
              aria-label={`Call ${PHONE_DISPLAY}`}
              title={`Call ${PHONE_DISPLAY}`}
            >
              <FiPhoneCall className="appointment__button-icon" />
              <span>Call Now</span>
              <div className="appointment__button-highlight"></div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Appointment;
